<script setup>
    const { data } = await useStatamicEntries().getEntryBySlug({
        collection: 'pages',
        value: currentSlug(),
    })

    useHead({
        title: (() => {
            if (data.value.title != 'Home') {
                return data.value.title
            }

            return null
        })(),
    })
</script>

<template>
    <SetPageBannerText :title="data.title" :text="data.page_banner_text" />

    <div v-if="data">
        <template v-for="section in data.content">
            <SetText v-if="section.type === 'text'" :fields="section" />
            <SetFeatureImage
                v-if="section.type === 'feature_image'"
                :fields="section"
            />
        </template>
    </div>

    <div v-else class="text-center">
        <h1 class="mb-2 text-brand2">Page not found</h1>
        <p>The page you requested couldn't be found.</p>
        <p>
            <NuxtLink to="/" class="text-brand1 underline hover:no-underline">
                Return to the home page
            </NuxtLink>
        </p>
    </div>
</template>
